<template>
  <section class="bg-gray-50 dark:bg-gray-900">
    <div class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
      <auth-form title="Bon retour parmis nous">
        <login-form />
      </auth-form>
    </div>
  </section>
</template>

<script>

import AuthForm from "@/components/auth/AuthForm.vue";
import LoginForm from "@/components/auth/LoginForm.vue";

export default {
  name: 'LoginView',
  components: {LoginForm, AuthForm }
}
</script>